import React from "react";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import MuiSnackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { notificationSelector } from "../../redux/notification/notificationSelector";
import { clearNotificationData } from "../../redux/notification/notificationActions";
import { renderEl } from "../../utils/parseData";

const Snackbar: React.FC = () => {
  const dispatch = useDispatch();
  const { notification } = useSelector(notificationSelector);

  const onDismissSnackBar = () => dispatch(clearNotificationData());

  return notification.message ? (
    createPortal(
      <div id="snackbar">
        <MuiSnackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={Boolean(notification.message)}
          onClose={onDismissSnackBar}
          message={notification.message}
          key={notification.message}
          autoHideDuration={3000}
        >
          <MuiAlert onClose={onDismissSnackBar} severity={notification.type || "info"} elevation={6} variant="filled">
            {notification.message}
          </MuiAlert>
        </MuiSnackbar>
      </div>,
      renderEl("root", "snackbar-el"),
    )
  ) : (
    <React.Fragment></React.Fragment>
  );
};

export default Snackbar;
